import { CHATBOT_SCRIPT_ID, CHATBOT_SCRIPT_SRC } from '../config';
import type { ChatbotLogger } from '../types';

/**
 * Appends the <script> tag for Applied Labs chatbot if not present.
 */
export function injectScript(logger: ChatbotLogger | Console = console): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (!document.getElementById(CHATBOT_SCRIPT_ID)) {
    try {
      const script = document.createElement('script');
      script.id = CHATBOT_SCRIPT_ID;
      script.src = CHATBOT_SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
      logger.info({
        type: 'client',
        context: 'Chatbot - injectScript',
        message: 'Script injected',
        sessionId: undefined,
      });
    } catch (err) {
      logger.error(
        {
          type: 'client',
          context: 'Chatbot - injectScript',
          message: 'Failed to inject script',
          sessionId: undefined,
        },
        { error: err },
      );
    }
  }
}

/**
 * Removes the <script> tag for Applied Labs chatbot if it exists.
 */
export function removeChatbotScript(logger: ChatbotLogger | Console = console): void {
  if (typeof document === 'undefined') return;

  try {
    const script = document.getElementById(CHATBOT_SCRIPT_ID);
    if (script) {
      script.remove();
      logger.info({
        type: 'client',
        context: 'Chatbot - removeChatbotScript',
        message: 'Script tag removed',
        sessionId: undefined,
      });
    }
  } catch (err) {
    logger.error(
      {
        type: 'client',
        context: 'Chatbot - removeChatbotScript',
        message: 'Failed to remove script tag',
        sessionId: undefined,
      },
      { error: err },
    );
  }
}
